import DataTable from "react-data-table-component";
import NoSearchDataComponent from "../country-components/no-search-data";

const customStylesTwo = {
  rows: {
    style: {
      maxHeight: "60px",
      minHeight: "52px",
      borderBottom: "none !important",
    },
  },
  headCells: {
    style: {
      paddingLeft: "8px",
      paddingRight: "8px",
    },
  },
  cells: {
    style: {
      paddingLeft: "8px",
      paddingRight: "8px",
      borderLeft: "1px solid #eaeaea",
      borderBottom: "1px solid #eaeaea !important",
    },
  },
};

const Table = ({ columns, data, paginationTotalRows, onSelectedRowsChange, onSort, defaultSortField, defaultSortAsc, paginationPerPage, onChangeRowsPerPage, onChangePage, paginationDefaultPage, noDataComponent, clearSelectedRows, selectedData, showTwoLevel, paginationIconPrevious, paginationIconNext, secondLevelRowDropdownValue }) => {
  const selectedRowValues = (row) => selectedData && selectedData.includes(row);
  const selectedRowCheck = (row) => row.key === "";
  const PaginationOptions = { rowsPerPageText: "Result per page", paginationRowsPerPageOptions: showTwoLevel ? [2 * secondLevelRowDropdownValue, 5 * secondLevelRowDropdownValue] : [10, 20, 30] };

  return (
    <DataTable
      className="trademo-datatable trademo-custom-table2"
      columns={columns}
      data={!!data && data.length > 0 ? data : []}
      progressPending={false}
      pagination
      paginationTotalRows={paginationTotalRows}
      selectableRows={showTwoLevel ? false : true}
      selectableRowSelected={selectedRowValues}
      selectableRowDisabled={(e) => selectedRowCheck(e)}
      onSort={(e, f) => onSort(e, f)}
      defaultSortField={defaultSortField}
      defaultSortAsc={defaultSortAsc}
      paginationPerPage={paginationPerPage}
      onSelectedRowsChange={({ selectedRows }) => onSelectedRowsChange(selectedRows)}
      onChangeRowsPerPage={(e, f) => onChangeRowsPerPage(e, f)}
      onChangePage={(e) => onChangePage(e)}
      paginationDefaultPage={paginationDefaultPage}
      highlightOnHover
      sortServer={true}
      customStyles={showTwoLevel ? customStylesTwo : {}}
      sortIcon={
        <svg xmlns="http://www.w3.org/2000/svg" height="16px" viewBox="0 -960 960 960" width="16px" fill="#101828">
          <path d="M480-96 216-360l51-51 177 177v-630h72v630l177-177 51 51L480-96Z" />
        </svg>
      }
      paginationIconPrevious={paginationIconPrevious ? paginationIconPrevious : null}
      paginationIconNext={paginationIconNext ? paginationIconNext : null}
      paginationRowsPerPageOptions={showTwoLevel ? [5 * secondLevelRowDropdownValue, 10 * secondLevelRowDropdownValue, 20 * secondLevelRowDropdownValue] : [10, 20, 30]}
      persistTableHead
      paginationComponentOptions={PaginationOptions}
      paginationIconFirstPage={<></>}
      paginationIconLastPage={<></>}
      clearSelectedRows={clearSelectedRows}
      noDataComponent={noDataComponent ? <NoSearchDataComponent content={noDataComponent} /> : <></>}
    />
  );
};
export default Table;
